import React from 'react';
import { motion } from 'framer-motion';
import { Image, Map, Mountain, Church, Navigation } from 'lucide-react';
export function VisualContentGrid() {
  const items = ['El Jardín del Edén y Mesopotamia', 'La Ruta del Éxodo', 'El Tabernáculo en el Desierto', 'La Conquista de Canaán', 'Jerusalén en la época de David', 'El Templo de Salomón (3D)', 'Los Reinos Divididos', 'El Exilio en Babilonia', 'Tierra Santa en tiempos de Jesús', 'El Mar de Galilea', 'Jerusalén en el siglo I', 'Los Viajes Misioneros de Pablo', 'Las 7 Iglesias de Apocalipsis', 'Reconstrucciones 3D de Ciudades', 'Mapas Topográficos Detallados', 'Clima y Vegetación por Región', 'Rutas Comerciales Antiguas', 'Sitios Arqueológicos Verificados'];
  // Helper to assign random icons for visual variety
  const getIcon = (index: number) => {
    const icons = [<Mountain className="w-4 h-4 md:w-5 md:h-5 text-gold-600" data-id="element-399" />, <Map className="w-4 h-4 md:w-5 md:h-5 text-gold-600" data-id="element-400" />, <div className="w-4 h-4 md:w-5 md:h-5 text-gold-600" data-id="element-401" />, <Church className="w-4 h-4 md:w-5 md:h-5 text-gold-600" data-id="element-402" />, <Navigation className="w-4 h-4 md:w-5 md:h-5 text-gold-600" data-id="element-403" />, <Image className="w-4 h-4 md:w-5 md:h-5 text-gold-600" data-id="element-404" />];
    return icons[index % icons.length];
  };
  return <section className="py-8 md:py-16 bg-navy-900 text-white content-section" data-id="element-405">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-406">
        <div className="text-center mb-6 md:mb-12" data-id="element-407">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-gold-300 mb-4" data-id="element-408">
            Tipos de Contenido Visual{' '}
            <span className="text-white highlight-burgundy" data-id="element-409">
              Que Explorarás Hoy
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base md:text-lg" data-id="element-410">
            Una colección{' '}
            <span className="font-bold text-gray-200" data-id="element-411">exhaustiva</span> diseñada
            para cubrir{' '}
            <span className="italic text-gold-200" data-id="element-412">
              cada aspecto geográfico y visual
            </span>{' '}
            de las Escrituras.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-4" data-id="element-413">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: Math.min(index * 0.05, 0.3),
          duration: 0.3
        }} className="flex items-center p-3 md:p-4 bg-navy-800 rounded-lg border border-navy-700 hover:border-gold-600/50 transition-colors duration-200 will-change-transform" data-id="element-414">
              <div className="mr-2 p-1.5 md:mr-3 md:p-2 bg-navy-900 rounded-full border border-navy-600 flex-shrink-0" data-id="element-415">
                {getIcon(index)}
              </div>
              <span className="text-gray-200 font-medium text-sm md:text-base" data-id="element-416">
                {item}
              </span>
            </motion.div>)}
        </div>

        <div className="mt-4 md:mt-8 text-center" data-id="element-417">
          <p className="text-gold-400 font-bold text-xl tracking-wide" data-id="element-418">
            ¡Y Mucho Más!
          </p>
        </div>
      </div>
    </section>;
}